import React, { useContext } from 'react';
import styled from 'styled-components';
import { fetchFromAppConfig } from 'src/config-store/ConfigFetcher';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { BRANDING_LOGO, CONFIG_TYPE } from 'src/constants/GlobalConstants';
import { BrandingConfig } from 'src/config-store/AppConfigTypes';
import { AmazonLogo } from 'src/images/AmazonLogo';
import { QueryParamKeys } from 'src/constants/UrlConstants';

const RegulatorBrandingContainer = styled.div``;

const brandingLogo = (logo: BRANDING_LOGO) => {
  return <AmazonLogo />;
};

const Branding = () => {
  const { preferredAccountId, clientId } = useContext(AuthContext);
  const brandingConfig: BrandingConfig = fetchFromAppConfig(
    preferredAccountId,
    clientId,
    CONFIG_TYPE.BRANDING,
  );

  const getRedirectUrl = () => {
    const hashQuery = window.location.hash.split('?')[1];
    const params = new URLSearchParams(hashQuery);
    const redirectTo = params.get(QueryParamKeys.REDIRECT_KEY);
    return redirectTo || brandingConfig.logoRedirectUrl;
  };

  return (
    <RegulatorBrandingContainer>
      <a href={getRedirectUrl()}>
        {brandingLogo(brandingConfig.brandingLogoName)}
      </a>
    </RegulatorBrandingContainer>
  );
};

export default Branding;
